module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-HeavyOblique.1be6ab47.woff2";